import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _CircularProgress;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useContext, useState, useEffect, useRef } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from '@mui/material/Button';
import Slider from '@mui/material/Slider';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import { Interweave } from 'interweave';
import NoSsr from '@mui/material/NoSsr';
import ContextProvider from '../../../context';
import CircularProgress from '../../../components/CircularProgress';
import * as courseReviewActions from '../../../actions/courseReview';
import SkillEvaluationForm from '../SkillEvaluationModal/SkillEvaluationForm';
import messages from './messages';
import s from './CourseReviewForm.scss';
import intlPropTypes from '../../../constants/intlPropTypes';
var MAX_FEEDBACK_LENGTH = 2000;
var DEFAULT_RATE = 5;
var CourseReviewForm = function CourseReviewForm(_ref) {
  var formatMessage = _ref.intl.formatMessage,
    _ref$isCongratsModal = _ref.isCongratsModal,
    isCongratsModal = _ref$isCongratsModal === void 0 ? false : _ref$isCongratsModal,
    handleClose = _ref.handleClose,
    getCourseReview = _ref.getCourseReview,
    loading = _ref.loading,
    lesson = _ref.lesson,
    review = _ref.review,
    course = _ref.course;
  var _useContext = useContext(ContextProvider),
    fetch = _useContext.fetch;
  var initialRate = useRef(DEFAULT_RATE);
  var _useState = useState(DEFAULT_RATE),
    _useState2 = _slicedToArray(_useState, 2),
    rate = _useState2[0],
    setRate = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    feedback = _useState4[0],
    setFeedback = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showSnackbarMessage = _useState6[0],
    setShowSnackbarMessage = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isSubmitting = _useState10[0],
    setIsSubmitting = _useState10[1];
  var _useState11 = useState(1),
    _useState12 = _slicedToArray(_useState11, 2),
    skillLevel = _useState12[0],
    setSkillLevel = _useState12[1];
  var maxLengthErrorText = formatMessage(messages.maxLength, {
    maxCharsQnt: MAX_FEEDBACK_LENGTH
  });
  var marks = [{
    value: 1,
    label: formatMessage(messages.notLikelyLabel)
  }, {
    value: 5,
    label: formatMessage(messages.likelyLabel)
  }];
  useEffect(function () {
    setRate(_.get(review, 'review.rate', DEFAULT_RATE));
    initialRate.current = _.get(review, 'review.rate', DEFAULT_RATE);
    setFeedback(_.get(review, 'review.feedback', ''));
    // quick fix set the default skill level of the end skill to Weakest
    if (!isCongratsModal) {
      setSkillLevel(_.get(review, 'userSkill.skillLevel', 1));
    }
  }, []);
  var handleFeedbackChange = function handleFeedbackChange(value) {
    setFeedback(value);
    setError(value && value.toString().trim().length > MAX_FEEDBACK_LENGTH);
  };
  var handleSave = function handleSave() {
    setIsSubmitting(true);
    var completedPartsCount = _.get(course, 'completedLessons') + _.get(course, 'completedQuizzes');
    var coursePartsTotal = _.get(course, 'totalLessons') + _.get(course, 'totalQuizzes');
    var data = {
      review: {
        rate: rate,
        feedback: feedback === null || feedback === void 0 ? void 0 : feedback.trim()
      },
      completedPartsCount: completedPartsCount,
      coursePartsTotal: coursePartsTotal,
      skillLevel: skillLevel
    };
    if (!isCongratsModal) {
      data.lessonId = lesson._id;
    }
    return fetch("/api/course_reviews/".concat(course._id), {
      method: 'PUT',
      body: JSON.stringify(data)
    }).then( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
        var resJson;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (res.ok) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return res.json();
            case 3:
              resJson = _context.sent;
              throw new Error(resJson && resJson.message);
            case 5:
              setShowSnackbarMessage(formatMessage(messages.leaveRatingSuccess));
              setIsSubmitting(false);
              setTimeout(function () {
                handleClose();
                getCourseReview(course._id);
              }, 1000);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }())["catch"](function (err) {
      setIsSubmitting(false);
      setShowSnackbarMessage(err.message);
    });
  };
  if (loading) {
    return /*#__PURE__*/_jsx("div", {
      className: s.loadingWrapper
    }, void 0, _CircularProgress || (_CircularProgress = /*#__PURE__*/_jsx(CircularProgress, {})));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isCongratsModal && /*#__PURE__*/_jsx(Typography, {
    variant: "h5",
    color: "primary",
    gutterBottom: true
  }, void 0, initialRate.current ? /*#__PURE__*/React.createElement(FormattedMessage, messages.currentCourseRatingTitle) : /*#__PURE__*/React.createElement(FormattedMessage, messages.rateCourseTitle)), /*#__PURE__*/_jsx(Typography, {
    variant: "subtitle1",
    color: "primary",
    gutterBottom: true
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.courseRatingLabel)), /*#__PURE__*/_jsx(Slider, {
    min: 1,
    max: 5,
    value: rate || DEFAULT_RATE,
    marks: marks,
    disabled: isSubmitting,
    classes: {
      root: s.sliderRoot,
      markLabel: s.sliderMarkLabel
    },
    onChange: function onChange(e, value) {
      return setRate(value);
    }
  }), /*#__PURE__*/_jsx(TextField, {
    multiline: true,
    fullWidth: true,
    variant: "outlined",
    type: "text",
    name: "feedback",
    margin: "normal",
    rows: 4,
    error: error || rate <= 3,
    value: feedback,
    onChange: function onChange(e) {
      return handleFeedbackChange(e.target.value);
    },
    label: formatMessage(messages.courseRatingFeedback),
    disabled: isSubmitting,
    helperText: error && maxLengthErrorText
  }), /*#__PURE__*/_jsx(SkillEvaluationForm, {
    setSkillLevel: setSkillLevel,
    skillLevel: skillLevel,
    classes: {
      title: classNames(s.skillEvaluationFormTitle, _defineProperty({}, s.leftTextAlign, !isCongratsModal)),
      sliderRoot: s.sliderRoot,
      sliderMarkLabel: s.skillEvaluationSliderMarkLabel,
      skillEvaluationContentWrapper: s.skillEvaluationContentWrapper,
      mark: s.skillEvaluationSliderMark
    }
  }), /*#__PURE__*/_jsx("div", {
    className: s.actions
  }, void 0, /*#__PURE__*/_jsx(Button, {
    "data-test-id": "vXuL9t8ekbVIfEm96eng6",
    fullWidth: true,
    color: "secondary",
    variant: "outlined",
    "data-test": "skip-course-review-btn",
    disabled: isSubmitting,
    onClick: handleClose
  }, void 0, isCongratsModal ? /*#__PURE__*/React.createElement(FormattedMessage, messages.skipLabel) : /*#__PURE__*/React.createElement(FormattedMessage, messages.closeLabel)), /*#__PURE__*/_jsx(Button, {
    "data-test-id": "Xw6Bff-3of0gS18tdcHge",
    fullWidth: true,
    color: "primary",
    variant: "outlined",
    "data-test": "save-course-review-btn",
    disabled: isSubmitting || error,
    onClick: handleSave
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.saveAndContinueLabel))), /*#__PURE__*/_jsx(Snackbar, {
    open: !!showSnackbarMessage,
    autoHideDuration: 2000,
    onClose: function onClose() {
      return setShowSnackbarMessage(false);
    },
    message: /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/_jsx(Interweave, {
      content: showSnackbarMessage
    }))
  }));
};
export default compose(injectIntl, withStyles(s), connect(function (state) {
  return {
    review: state.courseReview.review,
    loading: state.courseReview.loading,
    lesson: state.lessonDetails.lesson,
    course: state.courseDetails.course
  };
}, function (dispatch) {
  return bindActionCreators(_objectSpread({}, courseReviewActions), dispatch);
}))(CourseReviewForm);